<div *ngIf="isReportAccess">
  <div class="row table-div">
    <div class="indicatorName">Product name : {{ impactItems?.productName }}</div>
  </div>

  <div class="row table-div" *ngIf="impactItems?.componentItems?.length > 0">
    <ng-container *ngIf="impactItems?.isExport">
      <div class="tableHeading">
        <div>Details of product</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td *ngIf="!impactItems?.showProductComponentItems?.isComponentNameAllZero">
                Ingredients
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isWeightAllZero">
                Weight of ingredients
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialCountryNameAllZero">
                Country
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialSupplierNameAllZero">
                {{ reportResource.lblSupplierName }}
              </td>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let ingredientDetail of impactItems?.componentItems">
              <td *ngIf="!impactItems?.showProductComponentItems?.isComponentNameAllZero">
                {{ ingredientDetail.componentName }}
              </td>
              <td
                *ngIf="
                  !!ingredientDetail.weight &&
                  !impactItems?.showProductComponentItems?.isWeightAllZero
                "
              >
                {{ ingredientDetail?.weight.toString() | decimalFormatPipe }}
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialCountryNameAllZero">
                {{ ingredientDetail.materialCountryName }}
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialSupplierNameAllZero">
                {{ ingredientDetail.materialSupplierName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="!impactItems?.isExport && impactItems?.componentItems?.length > 0">
      <div class="tableHeadingForLifecycleStage">
        <div>Details of product</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td *ngIf="!impactItems?.showProductComponentItems?.isComponentNameAllZero">
                Ingredients
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isWeightAllZero">
                Weight of ingredients
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialCountryNameAllZero">
                Country
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialSupplierNameAllZero">
                {{ reportResource.lblSupplierName }}
              </td>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let ingredientDetail of impactItems?.componentItems">
              <td *ngIf="!impactItems?.showProductComponentItems?.isComponentNameAllZero">
                {{ ingredientDetail.componentName }}
              </td>
              <td
                *ngIf="
                  !!ingredientDetail.weight &&
                  !impactItems?.showProductComponentItems?.isWeightAllZero
                "
              >
                {{ ingredientDetail?.weight.toString() | decimalFormatPipe }}
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialCountryNameAllZero">
                {{ ingredientDetail.materialCountryName }}
              </td>
              <td *ngIf="!impactItems?.showProductComponentItems?.isMaterialSupplierNameAllZero">
                {{ ingredientDetail.materialSupplierName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <div
    class="row table-div"
    *ngIf="
      impactItems?.componentItems?.length > 0 &&
      getComponenttransportationItems(impactItems?.componentItems)
    "
  >
    <div class="tableHeadingForLifecycleStage">
      <div>Transportation of ingredient to the manufacturer</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td>Ingredients</td>
            <td
              *ngIf="!impactItems?.showIngredientProductComponentItems?.isTransportmodeNameAllZero"
            >
              {{ reportResource.lblModeTransport }}
            </td>
            <td *ngIf="!impactItems?.showIngredientProductComponentItems?.isFromplaceAllZero">
              {{ reportResource.lblFrom }}
            </td>
            <td *ngIf="!impactItems?.showIngredientProductComponentItems?.isToplaceAllZero">
              {{ reportResource.lblTo }}
            </td>
            <td *ngIf="!impactItems?.showIngredientProductComponentItems?.isDistanceAllZero">
              {{ reportResource.lblDistance }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <ng-container *ngFor="let componentDetail of impactItems?.componentItems">
              <ng-container
                *ngIf="
                  componentDetail?.componenttransportationItems?.length > 0 &&
                  componentDetail?.componenttransportationItems != null
                "
              >
                <!-- <td colspan="4"> -->
                <ng-container
                  *ngFor="let data of componentDetail?.componenttransportationItems; let i = index"
                >
                  <tr>
                    <ng-container
                      *ngIf="i == 0 || i > componentDetail?.componenttransportationItems?.length"
                    >
                      <td [attr.rowspan]="componentDetail?.componenttransportationItems?.length">
                        {{ componentDetail?.componentName }}
                      </td>
                    </ng-container>
                    <ng-container *ngIf="i == 0">
                      <td
                        *ngIf="
                          !impactItems?.showIngredientProductComponentItems
                            ?.isTransportmodeNameAllZero
                        "
                      >
                        {{ componentDetail.componenttransportationItems[i]?.transportmodeName }}
                      </td>
                      <td
                        *ngIf="
                          !impactItems?.showIngredientProductComponentItems?.isFromplaceAllZero
                        "
                      >
                        {{ componentDetail.componenttransportationItems[i]?.fromplace }}
                      </td>
                      <td
                        *ngIf="!impactItems?.showIngredientProductComponentItems?.isToplaceAllZero"
                      >
                        {{ componentDetail.componenttransportationItems[i]?.toplace }}
                      </td>
                      <td
                        *ngIf="!impactItems?.showIngredientProductComponentItems?.isDistanceAllZero"
                      >
                        {{
                          getShortDecimalFormat(
                            componentDetail.componenttransportationItems[i]?.distance
                          ) | decimalFormatPipe
                        }}
                      </td>
                    </ng-container>
                    <ng-container *ngIf="i != 0">
                      <td
                        *ngIf="
                          !impactItems?.showIngredientProductComponentItems
                            ?.isTransportmodeNameAllZero
                        "
                      >
                        {{ componentDetail.componenttransportationItems[i]?.transportmodeName }}
                      </td>
                      <td
                        *ngIf="
                          !impactItems?.showIngredientProductComponentItems?.isFromplaceAllZero
                        "
                      >
                        {{ componentDetail.componenttransportationItems[i]?.fromplace }}
                      </td>
                      <td
                        *ngIf="!impactItems?.showIngredientProductComponentItems?.isToplaceAllZero"
                      >
                        {{ componentDetail.componenttransportationItems[i]?.toplace }}
                      </td>
                      <td
                        *ngIf="!impactItems?.showIngredientProductComponentItems?.isDistanceAllZero"
                      >
                        {{
                          getShortDecimalFormat(
                            componentDetail.componenttransportationItems[i]?.distance
                          ) | decimalFormatPipe
                        }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row table-div" *ngIf="impactItems?.fillingItems?.length > 0">
    <div class="tableHeadingForLifecycleStage">
      <div>Manufacturing process</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td *ngIf="!impactItems?.showProductFillingItems?.isEnergyProcessNameAllZero">
              Process requirement
            </td>
            <td *ngIf="!impactItems?.showProductFillingItems?.isAmountAllZero">
              {{ reportResource.lblAmount }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <ng-container *ngFor="let fillingitem of impactItems?.fillingItems">
              <ng-container
                *ngIf="
                  fillingitem.fillingProcessItems?.length > 0 &&
                    fillingitem.fillingProcessItems != null;
                  else other_checked
                "
              >
                <ng-container *ngFor="let data of fillingitem?.fillingProcessItems; let i = index">
                  <ng-container *ngIf="i == 0; else fillingItemsOther">
                    <tr>
                      <td *ngIf="!impactItems?.showProductFillingItems?.isEnergyProcessNameAllZero">
                        {{ fillingitem.fillingProcessItems[i].energyProcessName }}
                      </td>
                      <td *ngIf="i == 0 && !impactItems?.showProductFillingItems?.isAmountAllZero">
                        {{ fillingitem.fillingProcessItems[i].amount | decimalFormatPipe }}
                      </td>
                    </tr>
                  </ng-container>
                  <ng-template #fillingItemsOther>
                    <tr>
                      <td *ngIf="!impactItems?.showProductFillingItems?.isEnergyProcessNameAllZero">
                        {{ fillingitem.fillingProcessItems[i].energyProcessName }}
                      </td>
                      <td *ngIf="!impactItems?.showProductFillingItems?.isAmountAllZero">
                        {{ fillingitem.fillingProcessItems[i].amount | decimalFormatPipe }}
                      </td>
                    </tr>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-template #other_checked>
                <tr>
                  <td style="text-align: left" class="caption"></td>
                  <td style="text-align: left"></td>
                </tr>
              </ng-template>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row table-div" *ngIf="impactItems?.productUseProcess?.length > 0">
    <div class="tableHeadingForLifecycleStage">
      <div>Product use process</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td *ngIf="!impactItems?.showProductUseProcess?.isEnergyProcessNameAllZero">
              Process requirement
            </td>
            <td *ngIf="!impactItems?.showProductUseProcess?.isAmountAllZero">
              {{ reportResource.lblAmount }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let processItem of impactItems?.productUseProcess">
            <ng-container
              *ngIf="
                processItem.productUseProcessItems?.length > 0 &&
                  processItem.productUseProcessItems != null;
                else other_checked
              "
            >
              <ng-container *ngFor="let data of processItem?.productUseProcessItems; let i = index">
                <ng-container *ngIf="i == 0; else processItemOther">
                  <tr>
                    <td *ngIf="!impactItems?.showProductUseProcess?.isEnergyProcessNameAllZero">
                      {{ processItem.productUseProcessItems[i].energyProcessName }}
                    </td>
                    <td *ngIf="i == 0 && !impactItems?.showProductUseProcess?.isAmountAllZero">
                      {{ processItem.productUseProcessItems[i].amount | decimalFormatPipe }}
                    </td>
                  </tr>
                </ng-container>
                <ng-template #processItemOther>
                  <tr>
                    <td *ngIf="!impactItems?.showProductUseProcess?.isEnergyProcessNameAllZero">
                      {{ processItem.productUseProcessItems[i].energyProcessName }}
                    </td>
                    <td *ngIf="!impactItems?.showProductUseProcess?.isAmountAllZero">
                      {{ processItem.productUseProcessItems[i].amount | decimalFormatPipe }}
                    </td>
                  </tr>
                </ng-template>
              </ng-container>
            </ng-container>
            <ng-template #other_checked>
              <tr>
                <td style="text-align: left" class="caption"></td>
                <td style="text-align: left"></td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row table-div" *ngIf="impactItems?.wholesaletransportList?.length > 0">
    <div class="tableHeadingForLifecycleStage">
      <div>Transportation of product to the filler</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isTransportmodeNameAllZero">
              {{ reportResource.lblModeTransport }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isFromplaceAllZero">
              {{ reportResource.lblFrom }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isToplaceAllZero">
              {{ reportResource.lblTo }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isDistanceAllZero">
              {{ reportResource.lblDistance }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let wholesaledetail of impactItems?.wholesaletransportList">
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isTransportmodeNameAllZero">
              {{ wholesaledetail.transportmodeName }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isFromplaceAllZero">
              {{ wholesaledetail.fromplace }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isToplaceAllZero">
              {{ wholesaledetail.toplace }}
            </td>
            <td *ngIf="!impactItems?.showProductWholesaletransportList?.isDistanceAllZero">
              {{ getShortDecimalFormat(wholesaledetail.distance) | decimalFormatPipe }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
